import { apiSlice } from '@/api'

export const helmetsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getHelmets: builder.query({
      query: (args) => {
        const { buildingId, page, from, to, size = 25 } = args
        return {
          url: `api/v2/helmets/report/building/${buildingId}`,
          method: 'GET',
          params: { page, from, to, size }
        }
      }
    }),
    getRealtimeHelmets: builder.query({
      query: (args) => {
        const { buildingId, page, from, to, size = 25 } = args
        return {
          url: `api/v2/helmets/building/${buildingId}`,
          method: 'GET',
          params: { page, from, to, size }
        }
      },
      forceRefetch({ currentArg, previousArg }) {
        return currentArg !== previousArg
      },
      serializeQueryArgs: ({ endpointName }) => {
        return endpointName
      }
      //   keepUnusedDataFor: 5
    })
  })
})

export const {
  useLazyGetHelmetsQuery,
  useLazyGetRealtimeHelmetsQuery,
  useGetHelmetsQuery,
  useGetRealtimeHelmetsQuery
} = helmetsApi
